import React from 'react';
import { FooterContainer, FooterText, FooterSubText } from './FooterElements';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterText>© Copyright 2026 Ron Joshi.</FooterText>
      <FooterSubText>site designed by Ron. Powered by React.</FooterSubText>
    </FooterContainer>
  );
};

export default Footer;
